import type { HTMLAttributes } from 'react'
import { cn } from '@/lib/utils'

/**
 * Base skeleton primitive — the single building block for every loading
 * placeholder in the app. Renders a theme-aware shimmer box.
 *
 * Design rule (see `.cursor/rules/loading-skeletons.mdc`): data/content that
 * is being fetched MUST be represented by skeletons that mirror the eventual
 * layout. Never render bare "Loading…" text or a bare spinner for content.
 *
 * Give it a width/height via className (e.g. `h-4 w-32`). For rounded shapes
 * use `rounded-full`. Compose multiple `<Skeleton />` boxes to mirror the
 * real layout you're standing in for.
 */
export function Skeleton({
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>): JSX.Element {
  return (
    <div
      className={cn('shimmer-skeleton rounded-md bg-muted', className)}
      {...props}
    />
  )
}
